import React from "react";
import {addIgnoreListItem} from "../../API/annotator";
import {getToken} from "../../Utils/Common";

function IgnoreListComponent() {

    const addItem = () => {
        let text = document.getElementById('ignoreItem').value;
        let select = document.getElementById('tagOption');
        let type = select.options[select.selectedIndex].text;
        if (text) {
            let item = {"Annotation": text, "type": type, "token": getToken()};
            addIgnoreListItem(item)
        }
    };

    return (<div className="row">
        &emsp; Hinzufügen: <div className="col-lg">
        <input className="normal col-lg" id="ignoreItem" type="text"/></div>
        Kategorie: <div className="col-4">
        <select className="custom-select" id="tagOption">
            <option>brands</option>
            <option>montagehoehe</option>
            <option>stundenlohnarbeiten</option>
            <option>beschilderung</option>
        </select></div>
        <div className="col-2">
            <button className="btn handwai-btn-create" onClick={() => addItem()}>Speichern</button>
        </div>
    </div>);
}

export default IgnoreListComponent;